import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

const initialState: any = {
    data: undefined,
    type: 'solidGauge',
    viewScale: false,
    viewThreshold: false,
};

const gaugeWidgetSlice = createSlice({
    name: 'gauge',
    initialState: initialState,
    reducers: {
        resetGaugeConfiguration: () => {
            return initialState;
        },
        setPredefinedGauge: (state: RootState, action: PayloadAction<any>) => {
            Object.keys(action.payload)?.forEach((key: string) => {
                const clone = JSON.parse(JSON.stringify(state['data'] ?? {}));
                if (key === 'multiDevice') {
                    state['data'] = { ...clone, [key]: action.payload[key] };
                } else {
                    state[key] = action.payload[key];
                }
            });
        },
        setGaugeChannels: (state: RootState, action: PayloadAction<any>) => {
            state.data = action.payload;
        },
        removeGaugeChannel: (state: RootState) => {
            state.data = {};
        },
        setGaugePreferences: (state: RootState, action: PayloadAction<any>) => {
            state[action.payload.key] = action.payload.value;
        },
    },

    extraReducers: (builder) => {
        builder.addCase('widgetConfiguration/setWidgetDevice', (state, action: any) => {
            if (action.payload.reset) state.data = { ...(state.data ?? {}), deviceId: action.payload.data.id };
        });
    },
});

export const {
    resetGaugeConfiguration,
    setGaugeChannels,
    removeGaugeChannel,
    setGaugePreferences,
    setPredefinedGauge,
} = gaugeWidgetSlice.actions;

export default gaugeWidgetSlice;
